// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatAlignRight = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="nonzero"
      d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
    />
  </svg>
);

export default FormatAlignRight;
